import ChangePassword from '../../pages/ChangePassword';
import { callAuthAPI } from '../../utils/apiUtils';
import { ROUTE_BACK_OFFICE_LOGIN } from '../../constants';
import * as apiConstants from '../../utils/apiUtilsConstants';

const boChangePassword = async (data) => {
  return callAuthAPI('bo/user/changepassword', data, apiConstants.METHOD_POST, true);
};

const BackOfficeChangePassword = () => {
  return (
    <ChangePassword 
      changePasswordFn={boChangePassword}
      loginRoute={ROUTE_BACK_OFFICE_LOGIN}
    />
  );
};

export default BackOfficeChangePassword;